var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "news-paper--newspaper-periodical-fold-content-entertainment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1100",
    stroke: "#fbfbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.922 6.895c-0.51 -2.411 -2.657 -4.013 -5.157 -3.888 -3.02 0.151 -7.749 0.502 -14.41 1.307 -6.66 0.805 -11.335 1.59 -14.303 2.162 -2.456 0.473 -4.145 2.539 -4.048 5 0.106 2.69 0.389 6.757 1.089 12.369 0.317 2.538 0.639 4.75 0.948 6.655",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1099",
    stroke: "#fbfbfb",
    strokeLinejoin: "round",
    d: "M5.442 39.958c0.219 2.546 2.206 4.447 4.755 4.619C13.282 44.785 18.129 45 25 45c6.87 0 11.718 -0.215 14.803 -0.423 2.55 -0.172 4.536 -2.073 4.755 -4.619C44.784 37.324 45 33.396 45 28s-0.216 -9.323 -0.442 -11.958c-0.219 -2.546 -2.206 -4.447 -4.755 -4.619C36.718 11.215 31.871 11 25 11c-6.87 0 -11.718 0.215 -14.803 0.423 -2.55 0.172 -4.536 2.073 -4.755 4.619C5.216 18.676 5 22.604 5 28s0.216 9.324 0.442 11.958Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1469",
    stroke: "#fbfbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 19h-8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1471",
    stroke: "#fbfbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 31h-8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1472",
    stroke: "#fbfbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M39 37H11",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1470",
    stroke: "#fbfbfb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 25h-8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1096",
    stroke: "#fbfbfb",
    strokeLinejoin: "round",
    d: "M25.087 28.823c0.086 1.706 1.384 3.004 3.09 3.09 0.991 0.05 2.257 0.087 3.823 0.087a76.33 76.33 0 0 0 3.822 -0.087c1.707 -0.086 3.005 -1.384 3.09 -3.09 0.05 -0.991 0.088 -2.257 0.088 -3.823a76.33 76.33 0 0 0 -0.087 -3.823c-0.086 -1.706 -1.383 -3.004 -3.09 -3.09A76.33 76.33 0 0 0 32 18a76.33 76.33 0 0 0 -3.823 0.087c-1.706 0.086 -3.004 1.384 -3.09 3.09A76.33 76.33 0 0 0 25 25c0 1.566 0.038 2.832 0.087 3.823Z",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsPaper);
export default __webpack_public_path__ + "static/media/news-paper.f0122d8035291557779cddd4f0a0de20.svg";
export { ForwardRef as ReactComponent };